export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_05.7a2e0168.jpg";